/** @format */

jQuery(document).ready(function ($) {
  function isMobile() {
    if (window.matchMedia("(max-width: 781px)").matches) {
      return true
    } else {
      return false
    }
  }

  $(".site-header__search-btn").on("click", function (e) {
    $(".site-header__search-container").toggleClass("site-header__search-container--visible")
  })

  $(".site-header__menu-icon").on("click", function (e) {
    if (isMobile()) {
      $(".site-header__navigation").toggleClass("site-header__navigation--open")
      $(".site-header").toggleClass("site-header--open")
      $(".site-header__menu-icon").toggleClass("site-header__menu-icon--close-x")
      $(".menu-item-parent").remove()
      $(".sub-menu-container").removeClass("show")
      $(".sub-menu").removeClass("show")
    }
  })

  $(".menu > .menu-item-has-children > a").on("click", function (e) {
    if (isMobile()) {
      e.preventDefault()
      var clone = $(this).clone().wrap("<span class='menu-item-parent'></span>").parent()
      $(this).parent().find("> .sub-menu-container").toggleClass("show")
      $(this).parent().find("> .sub-menu-container > .sub-menu > .menu-item-back").after(clone)
    }
  })

  $(".sub-menu > .menu-item-has-children > a").on("click", function (e) {
    if (isMobile()) {
      e.preventDefault()
      var clone = $(this).clone().wrap("<li class='menu-item-parent'></li>").parent()
      $(this).parent().find("> .sub-menu").toggleClass("show")
      $(this).parent().find("> .sub-menu > .menu-item-back").after(clone)
    }
  })

  $(".menu > .menu-item > .sub-menu-container > .sub-menu > li > a.menu-item-back").on("click", function (ev) {
    if (isMobile()) {
      ev.preventDefault()
      $(this).parent().parent().parent().toggleClass("show")
      $(this).parent().parent().find(".menu-item-parent").remove()
    }
  })

  $(".menu > .menu-item > .sub-menu-container > .sub-menu > .menu-item > .sub-menu > li > a.menu-item-back").on("click", function (ev) {
    if (isMobile()) {
      ev.preventDefault()
      $(this).parent().parent().toggleClass("show")
      $(this).parent().parent().find(".menu-item-parent").remove()
    }
  })
})
